import { render } from "./EnIntroBtn.vue?vue&type=template&id=5a48a0ea&scoped=true"
import script from "./EnIntroBtn.vue?vue&type=script&lang=js"
export * from "./EnIntroBtn.vue?vue&type=script&lang=js"

import "./EnIntroBtn.vue?vue&type=style&index=0&id=5a48a0ea&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a48a0ea"]])

export default __exports__